<template>
  <div class="chat-container">
    <!-- 顶部按钮栏 -->
    <div class="top-actions">
      <div class="left-actions">
        <a-button type="primary" @click="showAddAccountModal">
          <plus-outlined />添加TG账号
        </a-button>
        <a-button type="primary" click @click="showBindAgentModal">
          绑定代理IP
        </a-button>
        <a-button type="primary" danger @click="showDeleteAccountModal">
          <delete-outlined />删除TG账号
        </a-button>
        <a-button type="primary"   @click="showChatModal">进入私聊</a-button>
        <a-button type="primary"   @click="showAddFriendModal">
          <plus-outlined />加好友
        </a-button>
        <a-button type="primary"   @click="showFriendListModal">
          <UserOutlined />好友列表
        </a-button>
      </div>
      <div class="account-display">
        {{ currentAccount?.strAccount || "" }}
      </div>
      <div class="right-actions">
        <a-button type="primary" @click="showAgentModal">
          <ApiTwoTone />代理IP
        </a-button>
        <a-button type="primary" @click="handleGetChatData">
          <sync-outlined />获取聊天
        </a-button>
        <a-button type="primary" @click="showSendMessageModal">
          <mail-outlined />群发消息
        </a-button>
        <a-button type="primary" @click="showImportModal">
          <upload-outlined />导入私聊账号
        </a-button>
        <a-button type="primary" @click="showImportModalID">
          <upload-outlined />导入私聊数字ID
        </a-button>
        <a-button type="primary" @click="showTaskModal">
          <schedule-outlined />任务
        </a-button>
      </div>
    </div>

    <!-- 三栏布局 -->
    <div class="main-content">
      <!-- 左侧：添加的账号区域 -->
      <div class="left-panel">
        <a-spin :spinning="loading">
          <div
            class="account-item"
            v-for="account in accounts"
            :key="account.strAccount"
            @click="handleAccountSelect(account)"
            :class="{
              active: currentAccount?.strAccount === account.strAccount,
            }"
          >
            <a-avatar :size="40">{{ account.strAccount.charAt(1) }}</a-avatar>
            <div>{{ account.strAccount }}</div>
          </div>
          <div v-if="!loading && accounts.length === 0" class="no-data">
            暂无账号数据
          </div>
        </a-spin>
      </div>

      <!-- 中间：接收私聊名单 -->
      <div class="middle-panel">
        <div class="panel-title">接收私聊名单</div>
        <div class="chat-list">
          <div
            v-for="chat in chatList"
            :key="chat.chatId"
            class="chat-item"
            :class="{ active: selectedChat?.chatId === chat.chatId }"
            @click="selectChat(chat)"
          >
            <div class="chat-info">
              <span class="chat-name">{{ chat.username }}</span>
              <span class="chat-id">({{ chat.chatId }})</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：聊天内容 -->
      <div class="right-panel">
        <div class="message-container" ref="messageContainer">
          <!-- 显示选中的聊天信息 -->
          <div v-if="selectedChat" class="message-content">
            <div class="message-header">
              <span class="chat-name">{{ selectedChat.username }}</span>
              <span class="chat-id">({{ selectedChat.chatId }})</span>
            </div>
            <div class="message-body">
              {{ selectedChat.message }}
            </div>
          </div>
          <div v-else class="no-chat-selected">
            请选择一个聊天
          </div>
        </div>
        <div class="input-area">
          <!-- <a-textarea placeholder="输入消息..." :rows="4" /> -->
          <!-- <a-button type="primary" class="send-button" @click="showChatModal">发送</a-button> -->
        </div>
      </div>
    </div>

    <!-- 模态框 -->
    <AddTelegramAccountModal
      v-model:visible="addAccountModalVisible"
      @success="handleAddAccountSuccess"
    />

    <SendMessageModal
      v-model:visible="sendMessageModalVisible"
      :accounts="accounts"
      @success="handleSendMessageSuccess"
    />

    <AddFriendModal
    v-model:visible="addFriendModalVisible"
  />

  <FriendListModal
  v-model:visible="friendListModalVisible"
/>

    <a-modal
      v-model:visible="importModalVisible"
      title="导入私聊账号"
      :footer="null"
      width="800px"
    >
      <import-xlsx />
    </a-modal>

    <a-modal
    v-model:visible="importModalVisibleID"
    title="导入私聊数字ID"
    :footer="null"
    width="800px"
  >
    <import-xlsxID />
  </a-modal>

  <div v-if="privateChatModalVisible" class="private-chat-container">
    <privatechat v-model:visible="privateChatModalVisible" />
  </div>

    <!-- 添加任务管理模态框 -->
    <div v-if="taskModalVisible" class="task-manager-container">
      <task-manager v-model:visible="taskModalVisible" />
    </div>

    <div v-if="agentModalVisible" class="agent-manager-container">
      <agent-manager v-model:visible="agentModalVisible" />
    </div>
    <div v-if="agentBindModalVisible" class="agent-manager-container">
      <agent-bind-manager v-model:visible="agentBindModalVisible" />
    </div>

    <!-- 添加删除账号模态框 -->
    <delete-account-modal
      v-model:visible="deleteAccountModalVisible"
      @success="handleDeleteAccountSuccess"
    />
  </div>
</template>

<style scoped>
.chat-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.top-actions {
  padding: 12px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.account-display {
  font-size: 16px;
  font-weight: 500;
}

.right-actions {
  display: flex;
  gap: 8px;
}

.main-content {
  flex: 1;
  display: flex;
  background: #f0f2f5;
}

.left-panel {
  width: 200px;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  padding: 12px;
}

.middle-panel {
  width: 300px;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
}

.panel-title {
  padding: 12px;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 500;
}

.right-panel {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.message-container {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.input-area {
  padding: 12px;
  border-top: 1px solid #e8e8e8;
}

.send-button {
  margin-top: 8px;
  float: right;
}

.account-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.account-item:hover {
  background-color: #f5f5f5;
}

.account-item.active {
  background-color: #e6f7ff;
}

.chat-list {
  flex: 1;
  overflow-y: auto;
}

.left-actions {
  display: flex;
  gap: 8px;
}

.task-manager-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  padding: 20px;
}

.private-chat-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  padding: 20px;
}

.agent-manager-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  padding: 20px;
}


.chat-item {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}

.chat-item:hover {
  background-color: #f5f5f5;
}

.chat-item.active {
  background-color: #e6f7ff;
}

.chat-info {
  display: flex;
  align-items: center;
  gap: 4px;
}

.chat-name {
  font-weight: 500;
}

.chat-id {
  color: #666;
}

.message-content {
  padding: 16px;
}

.message-header {
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.message-body {
  white-space: pre-wrap;
  word-break: break-all;
}

.no-chat-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #999;
  font-size: 14px;
}

.chat-name {
  font-size: 16px;
  font-weight: 500;
  margin-right: 8px;
}

.chat-id {
  color: #666;
}
</style>

<script setup lang="ts">
import { ref, onMounted,onUnmounted } from "vue";
import {
  PlusOutlined,
  SyncOutlined,
  MailOutlined,
  UploadOutlined,
  DeleteOutlined,
  ScheduleOutlined,
  EditOutlined,
  UserOutlined,
  ApiTwoTone,
} from "@ant-design/icons-vue";
import AddTelegramAccountModal from "./AddTelegramAccountModal.vue";
import AddFriendModal from "./AddFriendModal.vue";
import SendMessageModal from "./SendMessageModal.vue";
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";
import ImportXlsx from "./ImportXlsx.vue";
import ImportXlsxID from "./ImportXlsxID.vue";
import DeleteAccountModal from "./DeleteAccountModal.vue";
import privatechat from "./privateChat/privatechat.vue"
import TaskManager from "./TaskManager.vue"; // 导入任务管理组件
import AgentManager from "./AgentManager.vue"; // 导入任务管理组件
import AgentBindManager from "./AgentBindManager.vue"; // 导入任务管理组件
import { useRouter } from "vue-router";
import { useStore } from 'vuex';
import FriendListModal from "./FriendListModal.vue";
const store = useStore();
const router = useRouter();
// 接口定义
interface AccountInfo {
  strAccount: string;
  strStatus?: string;
}

interface AccountListResponse {
  list: AccountInfo[];
}

interface ChatMessage {
  to: string;
  chatId: string;
  username: string;
  message: string;
}

const loading = ref(false);
const accounts = ref<AccountInfo[]>([]);
const currentAccount = ref<AccountInfo | null>(null);
const privateChatModalVisible = ref(false);
const addAccountModalVisible = ref(false);
const sendMessageModalVisible = ref(false);
const addFriendModalVisible = ref(false);
const friendListModalVisible = ref(false);
const importModalVisible = ref(false);
const importModalVisibleID = ref(false);
const deleteAccountModalVisible = ref(false);
const taskModalVisible = ref(false);
const agentModalVisible = ref(false);
const agentBindModalVisible = ref(false);
const chatList = ref<ChatMessage[]>([]);
const selectedChat = ref<ChatMessage | null>(null);

// 使用 Map 为每个账号存储其聊天列表
const accountChats = ref<Map<string, ChatMessage[]>>(new Map());

// 获取账号列表
const getAccountList = async () => {
  try {
    loading.value = true;
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }

    const client = TelegramClient.getInstance();
    const response = await client.getAccountList(username);
    console.log("【DEBUG】获取到的账号列表响应:", response);

    // 检查是否有 list 属性
    if (response && response.list) {
      accounts.value = response.list.map((item: any) => ({
        strAccount: item.strAccount,
        strStatus: item.strStatus || "",
      }));

      console.log("【DEBUG】处理后的账号列表:", accounts.value);

      if (!currentAccount.value && accounts.value.length > 0) {
        currentAccount.value = accounts.value[0];
        console.log("【DEBUG】已选择默认账号:", currentAccount.value);
        store.state.user.name = currentAccount.value.strAccount;
      }

    }
  } catch (error) {
    console.error("获取账号列表失败:", error);
  } finally {
    loading.value = false;
  }
};

// 监听账号列表返回
onMounted(async () => {
  try {
    const client = TelegramClient.getInstance();
    // 确保只连接一次
    await client.connect();
    console.log("组件已挂载，开始获取账号列表");
    getAccountList();
  } catch (error) {
    console.error("初始化失败:", error);
  }
});

// 选择账号
const selectAccount = (account: AccountInfo) => {
  currentAccount.value = account;

};

// 按钮点击处理方法
const showAddAccountModal = () => {
  addAccountModalVisible.value = true;
};

// 显示聊天界面
const showChatModal = () => {
  if(currentAccount.value == null) return;
  console.log("showChatModal");
  privateChatModalVisible.value = true;
};
 

const showAddFriendModal = () => {
 
  addFriendModalVisible.value = true;

};

const showFriendListModal = () => {
 
 friendListModalVisible.value = true;

};


//绑定代理IP
const showBindAgentModal = () => {
  agentBindModalVisible.value = true;
};

const showSendMessageModal = () => {
  sendMessageModalVisible.value = true;
};

const showImportModal = () => {
  importModalVisible.value = true;
};


const showImportModalID = () => {
  importModalVisibleID.value = true;
};

const showDeleteAccountModal = () => {
  deleteAccountModalVisible.value = true;
};

// 显示任务模态框方法
const showTaskModal = () => {
  taskModalVisible.value = true;
};

//显示代理ip
const showAgentModal = () => {
  agentModalVisible.value = true;
};



// 统一的更新聊天数据的函数
const updateChatData = (newChats: ChatMessage | ChatMessage[]) => {
  if (!currentAccount.value) return;

  const chatsArray = Array.isArray(newChats) ? newChats : [newChats];
  
  // 更新每个聊天
  chatsArray.forEach(newChat => {
    const existingChatIndex = chatList.value.findIndex(
      chat => String(chat.chatId) === String(newChat.chatId)
    );

    if (existingChatIndex !== -1) {
      // 更新现有聊天
      chatList.value = chatList.value.map((chat, index) => {
        if (index === existingChatIndex) {
          return { 
            ...chat, 
            message: newChat.message,
            timestamp: newChat.timestamp 
          };
        }
        return chat;
      });
    } else {
      // 添加新聊天
      chatList.value = [...chatList.value, {
        ...newChat,
        chatId: String(newChat.chatId)
      }];
    }
  });

  // 更新 Map 中存储的聊天列表
  accountChats.value.set(currentAccount.value.strAccount, [...chatList.value]);

  // 如果当前选中的聊天在更新列表中，也更新它
  if (selectedChat.value) {
    const updatedChat = chatList.value.find(
      chat => String(chat.chatId) === String(selectedChat.value?.chatId)
    );
    if (updatedChat) {
      selectedChat.value = { ...updatedChat };
    }
  }
};

// 获取聊天数据
const handleGetChatData = async () => {
  if(true) return;
  try {
    if (!currentAccount.value) {
      message.error("请先选择一个账号");
      return;
    }
    const sesionId = localStorage.getItem("session");
    if (!sesionId) {
      throw new Error("未找到用户sesionId");
    }
    
    const client = TelegramClient.getInstance();
    const response = await client.getPrivateChatData(currentAccount.value, sesionId);
    console.log("获取到的私聊数据:", response);
    
    if (response) {
      updateChatData(response);
      message.success("获取聊天数据成功");
    }
  } catch (error) {
    console.error("获取聊天数据失败:", error);
    message.error("获取聊天数据失败");
  }
};

const handChatData = (newMessage)=>{

  console.log('收到新消息:', newMessage);
    
    // 只处理当前选中账号的消息
    if (currentAccount.value && newMessage.username === currentAccount.value.strAccount) {
      updateChatData(newMessage);
    }

}  

const handOperationResult = (newMessage)=>{

   console.log('handOperationResult:', newMessage);
   var detail = newMessage.detail
   if(detail.code == 20000)//你在其他地方登陆
   {
       message.warning('您的账号在其他地方登陆');
       router.push("/login");
   } 

}


// WebSocket 消息监听
onMounted(() => {
  const client = TelegramClient.getInstance();
  client.addChatUpdateListener(handChatData);
  client.addOperationResultListener(handOperationResult);
  console.log("chatPage onMounted");
});

onUnmounted(() => {

  const client = TelegramClient.getInstance();
  client.removeChatUpdateListener(handChatData);
  client.removeOperationResultListener(handOperationResult);
 
});


// 修改账号选择处理函数
const handleAccountSelect = (account: AccountInfo) => {
  currentAccount.value = account;
  // 从 Map 中获取该账号的聊天列表，如果没有则显示空数组
  chatList.value = accountChats.value.get(account.strAccount) || [];
  //handleGetChatData(); // 获取新的聊天数据
  store.state.user.name = currentAccount.value.strAccount;
  console.log("handleAccountSelect");

};

// 模态框回调处理方法
const handleAddAccountSuccess = () => {
  // 添加账号成功后重新获取账号列表
  getAccountList();
};

const handleSendMessageSuccess = () => {
  console.log("发送消息成功");
};

// 处理删除账号成功
const handleDeleteAccountSuccess = async () => {
  deleteAccountModalVisible.value = false;
  await getAccountList();
  message.success("删除账号成功");
};

const selectChat = (chat: ChatMessage) => {
  selectedChat.value = chat;
  console.log('已选择聊天:', chat);
};

// 声明 window 上的 electron 属性
declare global {
  interface Window {
    electron: {
      ipcRenderer: {
        on: (channel: string, func: (...args: any[]) => void) => void;
        send: (channel: string, ...args: any[]) => void;
      };
    };
  }
}
</script>
